<template>
  <PageBreadcrumb
    :crumbs="[{
      label: 'Gestione Visualizzatori'
    }]"
  />
  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton @click="router.push('/visualizzatori/crea')">
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuovo Visualizzatore
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="email"
        >
          Email
        </SortableColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="viewer in data"
        :key="'viewer-table-' + viewer.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ viewer.email }}
        </td>
        <td class="p-2 text-right">
          <a
            href="#"
            title="Invia Reset Password"
            @click.prevent="resetPassword(viewer)"
          >
            <EnvelopeIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            href="#"
            title="Elimina Visualizzatore"
            @click.prevent="destroy(viewer)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>
    
<script setup>
import {
  EnvelopeIcon,
  PlusCircleIcon,
  TrashIcon
} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRouter } from 'vue-router';

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from '@/composables/datatable.js';

const router = useRouter()

const search = ref('')

const sortStatus = ref(["email", -1]);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/viewer-user/list",
  sortStatus,
  search,
  searchProperties: ['email']
})

const destroy = (viewer) => {
  action('delete', 'viewer-user/' + viewer.uuid, 'Visualizzatore eliminato con successo')
}

const resetPassword = (viewer) => {
  action('get', 'viewer-user/reset-password/' + viewer.uuid, 'E-Mail inviata con successo')
}
</script>
